import throttle from 'lodash/throttle';

export default () => {
  const header = document.querySelector('[data-sticky-header]');
  let currentScroll;

  function hasScrolledDown() {
    return window.scrollY > header.offsetHeight;
  }

  function checkScrollUp() {
    return window.scrollY < currentScroll;
  }

  function checkScroll() {
    const hasScrolled = hasScrolledDown();
    const isScrollingUp = checkScrollUp();

    if (hasScrolled && !isScrollingUp) {
      document.body.classList.add('is-hidden--header');
    } else {
      document.body.classList.remove('is-hidden--header');
    }

    currentScroll = window.scrollY;
  }

  window.addEventListener('scroll', throttle(checkScroll, 200));
};
